// extracted by mini-css-extract-plugin
export default {"rating":"YL-z","numberOfStars":"ZL-z","count":"_L-z","barGraphSpacing":"aM-z","barGraph":"bM-z"};